module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/team-6072084948ca15d3c23dcac3778ac9fb.png";